import React, { useState, useEffect, useCallback } from "react";
import { sendFormulario } from "../services/emailService";
import jsPDF from "jspdf";
import "./Formulario.css";

const preguntas = [
  "¿Trabaja con unidades de medida?",
  "¿Trabaja con entregas a cuenta de clientes?",
  "¿Trabaja con almacenes?",
  "¿Trabaja con divisas?",
  "¿Recargo de equivalencias?",
  "¿Trabaja con Intracomunitarias?",
  "¿Trabaja con partidas/lotes?",
  "¿Trabaja con cadenas de clientes?",
  "Configurar Informe de Facturas:",
  "Configurar informe de Albaranes:",
  "Configurar informe de pedidos:",
  "Configurar informe de Pedidos de compra:",
  "Longitud de cuentas contables:",
  "¿Configuración analítica?",
  "Número de empresas a configurar:",
  "¿Todas las empresas usan la misma longitud de cuentas?",
  "Empresa:",
  "Persona de contacto:"
];

const Formulario = () => {
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState(localStorage.getItem('generatedOtp') || "");
  const [otpExpiration, setOtpExpiration] = useState(localStorage.getItem('otpExpiration') ? new Date(localStorage.getItem('otpExpiration')) : null);
  const [otpVerified, setOtpVerified] = useState(false);
  const [respuestas, setRespuestas] = useState(Array(preguntas.length).fill(null));
  const [mensaje, setMensaje] = useState("");
  const [cargando, setCargando] = useState(false);
  const [mensajeEstado, setMensajeEstado] = useState({ tipo: "", texto: "" });
  const [showForm, setShowForm] = useState(false);
  const [otpCooldown, setOtpCooldown] = useState(parseInt(localStorage.getItem('otpCooldown')) || 0);
  const [cooldownActive, setCooldownActive] = useState(localStorage.getItem('cooldownActive') === 'true' || false);
  const [submissionsLeft, setSubmissionsLeft] = useState(3);

  // Función para obtener el contador de envíos
  const getSubmissionCount = () => {
    const count = parseInt(localStorage.getItem('submissionCount')) || 0;
    return count;
  };

  // Verificar límites al cargar
  useEffect(() => {
    const count = getSubmissionCount();
    setSubmissionsLeft(Math.max(0, 3 - count));
  }, []);

  // Generar OTP
  const generateOTP = useCallback(() => {
    const otp = Math.floor(100000 + Math.random() * 900000).toString();
    const expiration = new Date();
    expiration.setHours(expiration.getHours() + 1);
    return { otp, expiration };
  }, []);

  // Manejar generación de OTP
  const handleGenerateOTP = () => {
    setCargando(true);
    const { otp, expiration } = generateOTP();
    
    localStorage.setItem('generatedOtp', otp);
    localStorage.setItem('otpExpiration', expiration.toString());
    setGeneratedOtp(otp);
    setOtpExpiration(expiration);
    
    setOtpCooldown(600); // 10 minutos de cooldown
    setCooldownActive(true);
    localStorage.setItem('otpCooldown', '600');
    localStorage.setItem('cooldownActive', 'true');
    
    setMensaje(`✅ OTP generado: ${otp} (Válido por 1 hora)`);
    setCargando(false);
  };

  // Contador de cooldown
  useEffect(() => {
    let timer;
    if (cooldownActive && otpCooldown > 0) {
      timer = setTimeout(() => {
        const newCooldown = otpCooldown - 1;
        setOtpCooldown(newCooldown);
        localStorage.setItem('otpCooldown', newCooldown.toString());
      }, 1000);
    } else if (otpCooldown === 0 && cooldownActive) {
      setCooldownActive(false);
      localStorage.setItem('cooldownActive', 'false');
    }
    return () => clearTimeout(timer);
  }, [otpCooldown, cooldownActive]);

  // Verificar OTP
  const handleVerifyOTP = () => {
    const now = new Date();
    
    if (!otp) {
      setMensaje("❌ Ingresa el OTP");
      return;
    }

    if (otp !== generatedOtp) {
      setMensaje("❌ OTP incorrecto");
      return;
    }

    if (now > new Date(otpExpiration)) {
      setMensaje("❌ OTP expirado. Genera uno nuevo.");
      return;
    }

    setOtpVerified(true);
    setShowForm(true);
    setMensaje("✅ OTP verificado");
  };

  // Manejar cambios en respuestas
  const manejarCambioRespuesta = (indice, respuesta) => {
    const nuevasRespuestas = [...respuestas];
    nuevasRespuestas[indice] = respuesta;
    setRespuestas(nuevasRespuestas);
  };

  // Generar PDF
  const generarPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Formulario de Configuración", 10, 20);
    doc.setFontSize(12);
    
    let yPosition = 40;
    respuestas.forEach((respuesta, index) => {
      doc.text(`${preguntas[index]}: ${respuesta || "No especificado"}`, 10, yPosition);
      yPosition += 10;
    });

    doc.save("formulario_configuracion.pdf");
  };

  // Enviar formulario
  const manejarEnvio = async (e) => {
    e.preventDefault();
    
    if (respuestas.some(r => r === null)) {
      setMensajeEstado({ tipo: "error", texto: "⚠️ Completa todas las preguntas" });
      return;
    }

    if (submissionsLeft <= 0) {
      setMensajeEstado({ tipo: "error", texto: "❌ Límite diario alcanzado (3/día)" });
      return;
    }

    setCargando(true);
    try {
      await sendFormulario({ respuestas });
      setMensajeEstado({ tipo: "exito", texto: "✅ Formulario enviado" });
      generarPDF();

      // Actualizar el contador de envíos
      let count = getSubmissionCount();
      count += 1;
      localStorage.setItem('submissionCount', count.toString());

      setSubmissionsLeft(Math.max(0, 3 - count));
      resetForm();
    } catch (error) {
      setMensajeEstado({ 
        tipo: "error", 
        texto: error.message.includes('Límite') 
          ? "❌ " + error.message 
          : "❌ Error al enviar" 
      });
    } finally {
      setCargando(false);
    }
  };

  const resetForm = () => {
    setShowForm(false);
    setOtpVerified(false);
    setOtp("");
    setGeneratedOtp("");
    setOtpExpiration(null);
    localStorage.removeItem('generatedOtp');
    localStorage.removeItem('otpExpiration');
    setRespuestas(Array(preguntas.length).fill(null));
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div className="formulario-container">
      <h2 className="formulario-header">Formulario de Configuración</h2>
      
      <div className="submissions-counter">
        Envíos disponibles hoy: {submissionsLeft}/3
      </div>

      {!otpVerified ? (
        <div className="formulario-otp-section">
          <button
            className={`formulario-btn-generar ${cooldownActive ? 'disabled' : ''}`}
            onClick={handleGenerateOTP}
            disabled={cooldownActive || cargando || submissionsLeft <= 0}
          >
            {cargando ? "Generando..." : 
             cooldownActive ? `Espere ${formatTime(otpCooldown)}` : 
             submissionsLeft <= 0 ? "Límite alcanzado" : "Generar OTP"}
          </button>

          {mensaje && <p className={`mensaje ${mensaje.includes("✅") ? "success" : "error"}`}>{mensaje}</p>}

          <div className="otp-verification">
            <input
              type="text"
              className="formulario-input"
              placeholder="Ingresa el OTP de 6 dígitos"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              maxLength="6"
              disabled={submissionsLeft <= 0}
            />
            <button
              className="formulario-btn-verificar"
              onClick={handleVerifyOTP}
              disabled={!otp || otp.length !== 6 || submissionsLeft <= 0}
            >
              Verificar
            </button>
          </div>
        </div>
      ) : (
        <div className="formulario-preguntas">
          <p>Por favor, responde las siguientes preguntas:</p>
          
          {mensajeEstado.texto && (
            <p className={mensajeEstado.tipo === "exito" ? "mensaje-exito" : "mensaje-error"}>
              {mensajeEstado.texto}
            </p>
          )}

          <form onSubmit={manejarEnvio} className="formulario">
            {preguntas.map((pregunta, indice) => (
              <div key={indice} className="pregunta">
                <p>{pregunta}</p>
                {pregunta.endsWith(":") ? (
                  <input
                    type={pregunta.includes("Número") ? "number" : "text"}
                    value={respuestas[indice] || ""}
                    onChange={(e) => manejarCambioRespuesta(indice, e.target.value)}
                    placeholder={`Introduce ${pregunta.toLowerCase()}`}
                  />
                ) : (
                  <div className="opciones-radio">
                    <label>
                      <input
                        type="radio"
                        name={`pregunta-${indice}`}
                        value="Sí"
                        checked={respuestas[indice] === "Sí"}
                        onChange={() => manejarCambioRespuesta(indice, "Sí")}
                      />
                      Sí
                    </label>
                    <label>
                      <input
                        type="radio"
                        name={`pregunta-${indice}`}
                        value="No"
                        checked={respuestas[indice] === "No"}
                        onChange={() => manejarCambioRespuesta(indice, "No")}
                      />
                      No
                    </label>
                  </div>
                )}
              </div>
            ))}
            
            <button
              className="formulario-btn-enviar"
              type="submit"
              disabled={cargando || submissionsLeft <= 0}
            >
              {cargando ? "Enviando..." : 
               submissionsLeft <= 0 ? "Límite alcanzado" : "Enviar Respuestas"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Formulario;
